import { HttpMethod } from "../types/HttpMethod";
import { columnstypes } from "../types/tablecolumntypes";

const apiUrl = `${process.env.REACT_APP_BASE_URL}/rs/automation/process`;

export const downloadserverreport = (
  auth: string,
  folderName: number,
  countrycode: string
) => {
  const url = `${apiUrl}/downloadReport?folderName=${folderName}&countryCode=${countrycode}`;
  return fetch(url, {
    method: HttpMethod.Get,
    headers: {
      Authorization: auth,
    },
  });
};

export const getreportsummarydatafrmdb = (
  auth: string,
  filterdata: columnstypes
) => {
  const url = `${apiUrl}/reports`;
  const data = {
    runId: filterdata.runId,
    reportStartDate: filterdata.reportStartDate,
    reportEndDate: filterdata.reportEndDate,
    countryCode: filterdata.countryCode,
    status: filterdata.status,
    reportUser: filterdata.reportUser,
  };
  return fetch(url, {
    method: HttpMethod.Post,
    headers: { Authorization: auth, "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
};
